export default "__VITE_ASSET__Bi7V9AKb__"